// aluno/curso-detail.js — bottom-sheet com detalhes de curso (R3 restaurado).
//
// Origem (monólito v18 — App_Eloquence_v18_FREQ_COMPLETA.html):
//   • CSS  .curso-overlay / .curso-sheet-* — linhas 2821-3066
//   • HTML #cursoOverlay                    — linhas 5911-5948
//   • Dados cursosData                       — linhas 5952-6045
//   • openCurso() / closeCurso()             — linhas 6047-6140
//
// Restauração registrada em:
//   • docs/auditoria-regressoes-v19.md  (R3)
//   • docs/removidos-sem-autorizacao-v19.md (item #3)
//
// Conduta: user reportou que cards de curso no portal do aluno não abriam
// detalhes na v19. Este módulo reintroduz o bottom-sheet do v18 com paridade
// 1:1 de conteúdo (4 cursos) e visual (gradientes, hero, professor, tópicos).
//
// Exporta:
//   cursoDetail.open(id)  — abre o sheet com o curso solicitado
//   cursoDetail.close()   — fecha o sheet (idempotente)
//
// API consumida: nenhuma (dados estáticos por enquanto).
// Acessibilidade: ESC fecha; click no backdrop fecha; role=dialog/aria-modal.

// ── Dados dos cursos (paridade total com v18 ll. 5952-6045) ────────────────

const CURSOS = {
  'oratoria-power': {
    icon: '⚡',
    badge: '✦ NOVO',
    title: 'Oratória Power',
    tagline: 'Para quem quer dominar palcos, câmeras e grandes audiências.',
    grad: 'linear-gradient(145deg, #6A001F 0%, #B3002D 100%)',
    dotColor: '#B3002D',
    cargaHoraria: '—',
    modalidade: '—',
    professor: { nome: 'Yang Mendes', cargo: 'Especialista em Oratória' },
    desc: 'O Oratória Power é a formação mais completa da Eloquence para quem deseja comunicar com força, presença e autoridade. Seja em apresentações, lives, congressos ou reuniões de alto nível — você vai aprender a se posicionar e impactar qualquer plateia.',
    topics: [
      'Presença física e vocal em palco',
      'Como estruturar discursos de alto impacto',
      'Gestão de nervosismo e trava mental',
      'Storytelling aplicado à oratória',
      'Linguagem corporal e olhar de liderança',
      'Técnicas de improviso e resposta rápida',
    ],
    waMsg: 'Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20o%20Orat%C3%B3ria%20Power!',
  },
  'persuasao': {
    icon: '🧠',
    badge: '✦ NOVO',
    title: 'Técnicas de Persuasão',
    tagline: 'Influencie decisões e conquiste resultados com estratégia.',
    grad: 'linear-gradient(145deg, #1a0a3e 0%, #4a1080 100%)',
    dotColor: '#7c3aed',
    cargaHoraria: '—',
    modalidade: '—',
    professor: { nome: '—', cargo: '—' },
    desc: 'Aprenda os princípios psicológicos e práticos da persuasão para influenciar pessoas, fechar negócios, liderar equipes e construir relacionamentos poderosos. Uma habilidade indispensável para quem quer crescer.',
    topics: [
      'Princípios da influência e gatilhos mentais',
      'Comunicação assertiva e negociação',
      'Como criar rapport rapidamente',
      'Técnicas de ancoragem e reformulação',
      'Persuasão ética em vendas e liderança',
      'Argumentação e rebate de objeções',
    ],
    waMsg: 'Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20T%C3%A9cnicas%20de%20Persuas%C3%A3o!',
  },
  'corporativo': {
    icon: '🏢',
    badge: null,
    title: 'Cursos Corporativos',
    tagline: 'Treinamentos sob medida para equipes e lideranças.',
    grad: 'linear-gradient(145deg, #0a2a1a 0%, #0e5c35 100%)',
    dotColor: '#0e5c35',
    cargaHoraria: '—',
    modalidade: '—',
    professor: { nome: '—', cargo: '—' },
    desc: 'A Eloquence leva sua metodologia para dentro das empresas. Desenvolvemos treinamentos personalizados de comunicação, oratória e liderança para times de todos os tamanhos, do operacional ao C-level.',
    topics: [
      'Comunicação interna e reuniões eficazes',
      'Apresentações executivas e pitches',
      'Desenvolvimento de lideranças comunicadoras',
      'Oratória para vendas e atendimento',
      'Workshops in company (presencial ou online)',
      'Programas de mentoria individual',
    ],
    waMsg: 'Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20os%20Cursos%20Corporativos!',
  },
  'palestras': {
    icon: '🎤',
    badge: null,
    title: 'Palestras',
    tagline: 'Conteúdo de alto impacto para eventos, congressos e convenções.',
    grad: 'linear-gradient(145deg, #1a1200 0%, #7a4e00 100%)',
    dotColor: '#c87d00',
    cargaHoraria: '—',
    modalidade: '—',
    professor: { nome: '—', cargo: '—' },
    desc: 'Contrate palestras da Eloquence para o seu evento. Temas como comunicação, oratória, liderança e persuasão, entregues com energia, didática e resultados reais para o seu público.',
    topics: [
      'Palestra: O Poder da Comunicação',
      'Palestra: Oratória como diferencial competitivo',
      'Palestra: Liderança e Influência',
      'Palestra: Como se destacar em qualquer ambiente',
      'Formatos: presencial, online e híbrido',
      'Personalização por segmento e público',
    ],
    waMsg: 'Ol%C3%A1%2C%20gostaria%20de%20contratar%20uma%20Palestra%20da%20Eloquence!',
  },
};

// ── Estilos (injetados uma única vez) ─────────────────────────────────────

const CSS_ID = 'curso-detail-styles';

function ensureStyles() {
  if (document.getElementById(CSS_ID)) return;
  const style = document.createElement('style');
  style.id = CSS_ID;
  style.textContent = `
    .cd-overlay {
      position: fixed; inset: 0;
      background: rgba(0,0,0,0.6);
      z-index: 3000;
      display: flex; align-items: flex-end;
      opacity: 0; pointer-events: none;
      transition: opacity 0.28s;
      backdrop-filter: blur(4px);
      -webkit-backdrop-filter: blur(4px);
    }
    .cd-overlay.open { opacity: 1; pointer-events: all; }
    .cd-sheet {
      width: 100%; max-height: 90dvh;
      border-radius: 24px 24px 0 0;
      overflow: hidden;
      display: flex; flex-direction: column;
      transform: translateY(100%);
      transition: transform 0.32s cubic-bezier(.32,1.2,.42,1);
      background: #fff;
    }
    .cd-overlay.open .cd-sheet { transform: translateY(0); }
    .cd-hero { padding: 28px 24px 22px; position: relative; flex-shrink: 0; }
    .cd-handle { width: 38px; height: 4px; background: rgba(255,255,255,0.35); border-radius: 2px; margin: 0 auto 20px; }
    .cd-close {
      position: absolute; top: 20px; right: 20px;
      width: 32px; height: 32px; border-radius: 50%;
      background: rgba(255,255,255,0.18); border: none; color: #fff;
      font-size: 16px; cursor: pointer;
      display: flex; align-items: center; justify-content: center;
      transition: background 0.18s;
    }
    .cd-close:hover { background: rgba(255,255,255,0.3); }
    .cd-img-wrap {
      width: 100%; height: 180px; border-radius: 14px; overflow: hidden;
      margin-bottom: 16px; background: rgba(0,0,0,0.2);
      display: flex; align-items: center; justify-content: center;
    }
    .cd-img-placeholder { font-size: 52px; opacity: 0.5; }
    .cd-badge {
      display: inline-block; background: rgba(255,255,255,0.2); color: #fff;
      font-size: 10px; font-weight: 800; letter-spacing: 1.5px; text-transform: uppercase;
      padding: 4px 10px; border-radius: 100px; margin-bottom: 10px;
    }
    .cd-title { font-size: 26px; font-weight: 900; color: #fff; letter-spacing: -0.5px; margin-bottom: 8px; }
    .cd-tagline { font-size: 14px; font-weight: 500; color: rgba(255,255,255,0.75); line-height: 1.5; }
    .cd-body { background: #fff; flex: 1; overflow-y: auto; padding: 24px 24px 40px; }
    .cd-meta { display: flex; gap: 10px; flex-wrap: wrap; margin-bottom: 20px; }
    .cd-chip {
      display: inline-flex; align-items: center; gap: 6px;
      background: #F0F0F0; border-radius: 100px; padding: 6px 14px;
      font-size: 12px; font-weight: 700; color: #333;
    }
    .cd-desc { font-size: 15px; font-weight: 500; color: #333; line-height: 1.7; margin-bottom: 24px; }
    .cd-prof-title, .cd-topics-title {
      font-size: 11px; font-weight: 800; color: #9B9B9B;
      letter-spacing: 1.5px; text-transform: uppercase; margin-bottom: 12px;
    }
    .cd-prof {
      display: flex; align-items: center; gap: 14px;
      background: #F5F5F5; border-radius: 16px; padding: 14px 16px; margin-bottom: 24px;
    }
    .cd-prof-avatar {
      width: 52px; height: 52px; border-radius: 50%; overflow: hidden;
      background: #ddd; flex-shrink: 0;
      display: flex; align-items: center; justify-content: center;
      font-size: 22px;
    }
    .cd-prof-name { font-size: 15px; font-weight: 800; color: #0A0A0A; margin-bottom: 2px; }
    .cd-prof-role { font-size: 12px; font-weight: 500; color: #6B6B6B; }
    .cd-topics { display: flex; flex-direction: column; gap: 10px; margin-bottom: 28px; }
    .cd-topic {
      display: flex; align-items: flex-start; gap: 10px;
      background: #F5F5F5; border-radius: 12px; padding: 12px 14px;
      font-size: 13px; font-weight: 600; color: #1a1a1a; line-height: 1.4;
    }
    .cd-topic-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; margin-top: 4px; }
    .cd-wa-btn {
      display: flex; align-items: center; justify-content: center; gap: 10px;
      width: 100%; padding: 16px; border-radius: 16px; border: none;
      background: linear-gradient(90deg, #25D366 0%, #128C7E 100%);
      color: #fff; font-size: 15px; font-weight: 800;
      cursor: pointer; text-decoration: none; letter-spacing: -0.2px;
      transition: transform 0.18s, box-shadow 0.18s;
      box-shadow: 0 4px 18px rgba(37,211,102,0.35);
    }
    .cd-wa-btn:hover  { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(37,211,102,0.45); }
    .cd-wa-btn:active { transform: scale(0.98); }
  `;
  document.head.appendChild(style);
}

// ── Helpers de escape ────────────────────────────────────────────────────

function esc(str) {
  return String(str ?? '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

// ── Construção do overlay ────────────────────────────────────────────────

function buildOverlay(c) {
  const overlay = document.createElement('div');
  overlay.className = 'cd-overlay';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-label', `Detalhes do curso ${c.title}`);

  const showBadge   = !!c.badge;
  const showCarga   = c.cargaHoraria && c.cargaHoraria !== '—';
  const showModal   = c.modalidade   && c.modalidade   !== '—';
  const showProf    = c.professor && c.professor.nome && c.professor.nome !== '—';
  const profInitial = showProf ? esc(c.professor.nome.charAt(0)) : '';

  overlay.innerHTML = `
    <div class="cd-sheet">
      <div class="cd-hero" style="background:${c.grad}">
        <div class="cd-handle"></div>
        <button class="cd-close" type="button" aria-label="Fechar">✕</button>
        <div class="cd-img-wrap">
          <span class="cd-img-placeholder">${esc(c.icon)}</span>
        </div>
        ${showBadge ? `<div class="cd-badge">${esc(c.badge)}</div>` : ''}
        <div class="cd-title">${esc(c.title)}</div>
        <div class="cd-tagline">${esc(c.tagline)}</div>
      </div>
      <div class="cd-body">
        ${(showCarga || showModal) ? `
          <div class="cd-meta">
            ${showCarga ? `<span class="cd-chip">⏱ ${esc(c.cargaHoraria)} de curso</span>` : ''}
            ${showModal ? `<span class="cd-chip">📍 ${esc(c.modalidade)}</span>` : ''}
          </div>` : ''}
        <p class="cd-desc">${esc(c.desc)}</p>
        ${showProf ? `
          <div class="cd-prof-title">PROFESSOR</div>
          <div class="cd-prof">
            <div class="cd-prof-avatar" style="background:${c.dotColor};color:#fff;font-weight:800">${profInitial}</div>
            <div style="flex:1">
              <div class="cd-prof-name">${esc(c.professor.nome)}</div>
              <div class="cd-prof-role">${esc(c.professor.cargo)}</div>
            </div>
          </div>` : ''}
        <div class="cd-topics-title">O QUE VOCÊ VAI APRENDER</div>
        <div class="cd-topics">
          ${c.topics.map(t =>
            `<div class="cd-topic"><span class="cd-topic-dot" style="background:${c.dotColor}"></span>${esc(t)}</div>`
          ).join('')}
        </div>
        <a class="cd-wa-btn" href="https://wa.me/5571982505900?text=${c.waMsg}"
           target="_blank" rel="noopener">💬 Quero me inscrever</a>
      </div>
    </div>
  `;
  return overlay;
}

// ── Estado e API pública ─────────────────────────────────────────────────

let _currentOverlay = null;
let _escHandler     = null;

function close() {
  if (!_currentOverlay) return;
  _currentOverlay.classList.remove('open');
  document.body.style.overflow = '';
  if (_escHandler) {
    document.removeEventListener('keydown', _escHandler);
    _escHandler = null;
  }
  const overlay = _currentOverlay;
  _currentOverlay = null;
  // Remove do DOM após a transição (evita acumular nodes)
  setTimeout(() => overlay.remove(), 320);
}

function open(id) {
  const c = CURSOS[id];
  if (!c) {
    console.warn(`[curso-detail] curso "${id}" não encontrado.`);
    return;
  }
  ensureStyles();
  // Se já houver um aberto, fecha imediatamente sem animação
  if (_currentOverlay) {
    _currentOverlay.remove();
    _currentOverlay = null;
    if (_escHandler) {
      document.removeEventListener('keydown', _escHandler);
      _escHandler = null;
    }
  }

  const overlay = buildOverlay(c);
  document.body.appendChild(overlay);
  _currentOverlay = overlay;

  // Backdrop click fecha
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) close();
  });
  // Botão ✕ fecha
  overlay.querySelector('.cd-close').addEventListener('click', close);

  // ESC fecha
  _escHandler = (e) => { if (e.key === 'Escape') close(); };
  document.addEventListener('keydown', _escHandler);

  document.body.style.overflow = 'hidden';
  // Força reflow para a transição rodar
  requestAnimationFrame(() => overlay.classList.add('open'));
}

export const cursoDetail = { open, close };
